import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef, Inject } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Gallery, GalleryItem, ImageSize, ImageItem } from "ng-gallery";
import { Lightbox } from "ng-gallery/lightbox";
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserProfileComponent } from '../modals/user-profile/user-profile.component';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { MatSelect } from '@angular/material/select';

import { ReplaySubject, Subject } from 'rxjs';

import { take, takeUntil } from 'rxjs/operators';

// import { Bank, BANKS } from './demo-data';
import { Bank, BANKS } from './trackdemo-data'

export interface Element {
  createdOn: string
  farmerName: string;
  stateName: string;
  districtName: string;
  totalTree: number;
  treeHarvested: number;
  harvest: number;
  rankInDistrict: string;
  rankInState: string;

}

interface sortBy {
  value: string;
  viewValue: string;
}

export interface BankGroup {
  name: string;
  banks: Bank[];
}

@Component({
  selector: 'app-track-your-harvest',
  templateUrl: './track-your-harvest.component.html',
  styleUrls: ['./track-your-harvest.component.scss']
})
export class TrackYourHarvestComponent implements OnInit {

  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  statedata = [];
  districtdata = [];
  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // banks: Bank[];
  /*add for mat sort */
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  @ViewChild(MatSort) sort: MatSort;
  // displayedColumns = ["images", "createdOn", "farmerName", "stateName", "districtName", "crop", "totalTree", "treeHarvested", "harvest"];
  displayedColumns = ["images", "createdOn", "farmerName", "stateName", "districtName", "crop", "harvest"];

  dataSource = new MatTableDataSource<Element>([]);

  avgUser: any = [];
  totalUser;
  userdata;

  HarvestDetailList = [];
  HarvestDetail;

  selectedSorting: string;
  selectFilterData1;

  sortBy = [
    { value: '0', viewValue: 'Most Recent' },
    { value: '1', viewValue: 'Oldest Rating' },
    { value: '2', viewValue: 'Highest Rating' },
    { value: '3', viewValue: 'Lowest Rating' },

  ];
  today = new Date();
  customDate = false;
  currentD = this.datePipe.transform(this.today, 'dd/MM/yyyy');
  datepicker = [
    { value: '0', viewValue: '1 Week', startDate: new Date(new Date().setDate(new Date().getDate() - 7)), endDate: new Date() },
    { value: '1', viewValue: '1 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 30)), endDate: new Date() },
    { value: '2', viewValue: '3 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 90)), endDate: new Date() },
    { value: '3', viewValue: '6 Months', startDate: new Date(new Date().setDate(new Date().getDate() - 180)), endDate: new Date() },
    { value: '4', viewValue: '1 Year', startDate: new Date(new Date().setDate(new Date().getDate() - 365)), endDate: new Date() },
    { value: '5', viewValue: 'Custom Date' }
  ];
  ranges: any = {
    // 'Today': [moment(), moment()],
    // 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()]
  }
  filterData = [
    //  { value: '0', viewValue: 'App Version' },
    { value: '1', viewValue: 'State' },
    //{ value: '2', viewValue: 'Language' },
  ];
  public matChipArray = [];

  selectFilterData;
  searchData = "";
  filterbyText = "";
  filterbyAppVersion = "";
  filterbystate = [];
  filterbydistrict = [];
  filterbylanguage = "";
  newDataList = [];
  newData;

  mostrecent;
  oldRating;
  highestRating;
  lowestRating;

  //sorting table
  dataSourcelist;




  formdate = "";
  filterbyformdate = "";
  filterbytodayte = "";
  todayte = "";
  filterbynamedata = "";
  namedata = "";
  state = "";
  district = "";
  length: number;
  exportcsvdata = false;
  userlist = [];
  filterbymonthData = "";
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  datashow = true;
  maxDate; minDate;
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  avgUserCount: any = [];
  totalUserCount;
  regexStr: string | RegExp;
  submitted: boolean;
  reg: string | RegExp;
  response: Object;
  hidepagination: boolean;

  /** list of banks */
  protected banks: Bank[] = BANKS;

  /** total number of available entries */
  public allBanksSize = BANKS.length;

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  public districtMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  public districtMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  /** local copy of filtered banks to help set the toggle all checkbox state */
  protected filteredBanksCache: Bank[] = [];

  protected filteredDistrictCache = [];
  isIndeterminateDistrict = false;
  isCheckedDistrict = false;
  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  @ViewChild('multiSelectDistrict', { static: true }) multiSelectDistrict: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();
  // filterbydistrictdata: any;
  // totalState: string;

  // protected banks: Bank[] = BANKS;
  // public bankMultiCtrl: FormControl = new FormControl();
  // public allBanksSize = BANKS.length;
  // public districtMultiCtrl: FormControl = new FormControl();
  // public filteredBanksMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  // public filteredDistrictMulti: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  // /** local copy of filtered banks to help set the toggle all checkbox state */


  // /** control for the MatSelect filter keyword multi-selection */
  // public bankMultiFilterCtrl: FormControl = new FormControl();
  // protected filteredBanksCache: Bank[] = [];

  // protected filteredDistrictCache = [];
  // isIndeterminateDistrict = false;
  // isCheckedDistrict = false;
  // /** flags to set the toggle all checkbox state */
  // isIndeterminate = false;
  // isChecked = false;


  // public districtMultiFilterCtrl: FormControl = new FormControl();
  // @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;
  // @ViewChild('multiSelectDistrict', { static: true }) multiSelectDistrict: MatSelect;
  // protected _onDestroy = new Subject<void>();




  // currentMonthCount;
  // previousMonthCount;
  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) { }
  categoryForm: FormGroup;
  ngOnInit(): void {

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.selectedSorting = this.sortBy[0].viewValue;

    this.totalTrackYourHarvest();
    this.getHarvestDetail();
    this.getHeader();

    this.filteredBanksMulti.next(this.banks.slice());

    this.filteredDistrictMulti.next(this.selectDistrict.slice());

    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
        this.setToggleAllCheckboxState();
      });


    this.districtMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDistrictMulti();
        this.districtSetToggleAllCheckboxState();
      });

    this.districtMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.districtSetToggleAllCheckboxState();
      });

    // listen for multi select field value changes
    this.bankMultiCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.setToggleAllCheckboxState();
      });


  }
  suche() {
    setTimeout(() => {
      (document.querySelectorAll("#search1 div input")[1] as any).placeholder = "Search State";
    }, 5);
  }

  addHarvestCrop() {
    this.router.navigateByUrl('/add-harvest-crop');
  }

  notFound() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll("#search1 div") as any).innerText = "not found";
      }, 10);
    }
  }
  notFoundDistrict() {
    if (this.isChecked == false) {
      setTimeout(() => {
        (document.querySelectorAll("#search1 div") as any).innerText = "not found";
      }, 10);
    }
  }
  sucheDistrict() {
    setTimeout(() => {
      (document.querySelectorAll("#search1 div input")[1] as any).placeholder = "Search District";
    }, 5)
  }
  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanksMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: Bank, b: Bank) => a && b && a.id === b.id;
      });
  }

  protected districtSetInitialValue() {
    this.filteredDistrictMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelectDistrict.compareWith = (a: Bank, b: Bank) => a && b && a.id === b.id;
      });
  }

  protected filterBanksMulti() {
    if (!this.banks) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksCache = this.banks.slice();
      this.filteredBanksMulti.next(this.filteredBanksCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredBanksCache = this.banks.filter((bank: any) => bank.stateName.toLowerCase().indexOf(search) > -1);
    this.filteredBanksMulti.next(this.filteredBanksCache);
  }

  protected filterDistrictMulti() {
    if (!this.eligbleDistricts()) {
      return;
    }
    // get the search keyword
    let search = this.districtMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistrictCache = this.eligbleDistricts().slice();
      this.filteredDistrictMulti.next(this.filteredDistrictCache);
      this.selectDistrict = this.filteredDistrictCache;
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks

    this.filteredDistrictCache = this.eligbleDistricts().filter((item: any) => item.toLowerCase().indexOf(search) > -1);
    this.filteredDistrictMulti.next(this.filteredDistrictCache);
    this.selectDistrict = this.filteredDistrictCache;
  }

  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBanksCache.forEach(el => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredBanksCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredBanksCache.length;
    }
  }

  protected districtSetToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.districtMultiCtrl && this.districtMultiCtrl.value) {
      this.filteredDistrictCache.forEach(el => {
        if (this.districtMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrict = filteredLength > 0 && filteredLength < this.filteredDistrictCache.length;
      this.isCheckedDistrict = filteredLength > 0 && filteredLength === this.filteredDistrictCache.length;
    }
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredBanksMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }

  toggleSelectAlldistrict(selectAllValue: boolean) {
    this.filteredDistrictMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.districtMultiCtrl.patchValue(this.eligbleDistricts());
        } else {
          this.districtMultiCtrl.patchValue([]);
        }
      });
  }

  selectDistrict = [];

  filterMyOptions(items) {
    this.selectDistrict = [];
    if (this.bankMultiCtrl.value.length === 0) {

    } else {
      this.bankMultiCtrl.value.forEach(element => {
        this.selectDistrict = this.selectDistrict.concat(element.districtName);
      });
    }
  }

  eligbleDistricts() {
    let dist = [];
    if (this.bankMultiCtrl.value.length === 0) {

    } else {
      this.bankMultiCtrl.value.forEach(element => {
        dist = dist.concat(element.districtName);
      });
    }
    return dist;
  }








  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getHarvestDetail() {
    this.spinner.show();
    var postdata = {
      "fromDate": "",
      "toDate": "",
      "month": "",
      "state": "",
      "district": "",
      "mostRcent": true,
      "oldest": false,
      "highestRating": false,
      "lowestRating": false,
      "search": "",
      "pageNumber": 0,
      "pageSize": 10
    }

    this._userService.GetHarvestCropDetails(postdata).subscribe(data => {
      this.HarvestDetail = data;
      this.paginationProperty = this.HarvestDetail.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(this.HarvestDetail.result.data.list);

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });

  }

  totalTrackYourHarvest() {
    this._userService.getTotalTrackYourHarvest().subscribe(data => {
      this.totalUser = data;
      this.avgUser = this.totalUser.result.data;
    });
  }
  getHeader() {
    this._userService.getTrackHeader().subscribe(data => {
      this.totalUserCount = data;
      this.avgUserCount = this.totalUserCount.result.data;
    });
  }


  startdata; enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss') : null;
      this.startdata = dates.startDate ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss') : null;
    }

  }

  //filters

  // filterUserDetail(data: any, filtername) {

  //   if (filtername == 'search') {
  //     this.filterbyText = "";
  //     if (this.searchData) {
  //       this.filterbyText = this.searchData;
  //     }
  //   }
  //   else {
  //     this.filterbylanguage = "";
  //     this.filterbystate = "";
  //     this.filterbyAppVersion = "";
  //     if (this.selectFilterData == "Language") {
  //       this.filterbylanguage = data;
  //     }
  //     else if (this.selectFilterData == "State") {
  //       this.filterbystate = data;
  //     }
  //     else if (this.selectFilterData == "App Version") {
  //       this.filterbyAppVersion = data;
  //     }
  //   }

  //   // for sorting
  //   let mostrecent = false;
  //   let oldRating = false;
  //   let highestRating = false;
  //   let lowestRating = false;

  //   if (this.selectedSorting === 'Most Recent') {
  //     mostrecent = true;
  //   }
  //   else if (this.selectedSorting === 'Oldest Rating') {
  //     oldRating = true;
  //   }
  //   else if (this.selectedSorting === 'Highest Rating') {
  //     highestRating = true;
  //   }
  //   else if (this.selectedSorting === 'Lowest Rating') {
  //     lowestRating = true;
  //   }

  //   var postdata = {
  //     "fromDate": this.datePipe.transform(this.form.controls.start.value, 'yyyy-MM-ddThh:mm:ss'),
  //     "toDate": this.datePipe.transform(this.form.controls.end.value, 'yyyy-MM-ddThh:mm:ss'),
  //     // "appVersion": this.filterbyAppVersion,
  //     // "language": this.filterbylanguage,
  //     "state": this.filterbystate,
  //     "mostRcent": mostrecent,
  //     "oldest": oldRating,
  //     "highestRating": highestRating,
  //     "lowestRating": lowestRating,
  //     "search": this.filterbyText,
  //     "pageNumber": this.pageIndex,
  //     "pageSize": this.pageSize
  //   }
  //   this._userService.getHarvestDetail(postdata).subscribe(data => {

  //     this.userdata = data;
  //     this.HarvestDetail = this.userdata.result.data.list;
  //     this.paginationProperty = this.userdata.result.data;
  //     this.length = this.paginationProperty.totalItems;
  //     this.previousPageIndex = this.paginationProperty.previousPageIndex;
  //     this.hasNextPage = this.paginationProperty.hasNextPage;
  //     this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
  //     this.pageIndex = this.paginationProperty.pageNumber;

  //     this.dataSource = new MatTableDataSource(this.HarvestDetail);
  //     this.dataSource.sort = this.sort;
  //     //  this.dataSource.paginator = this.paginator;
  //     this.spinner.hide();
  //   });

  // }


  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage; hasPreviousPage; nextPageNumber; pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;

  previousPageIndex; pagechangeevent;
  searchText = ""; searchDate = "";


  public getServerData(event?: PageEvent) {

    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        "fromDate": this.startdata,
        "toDate": this.enddata,
        "state": this.filterbystate.join(","),
        "district": this.filterbydistrict.join(","),
        "mostRcent": this.mostrecent,
        "oldest": this.oldRating,
        "highestRating": this.highestRating,
        "lowestRating": this.lowestRating,
        "search": this.filterbyText,
        "pageNumber": this.pageIndex,
        "pageSize": this.pageSize
      }

      this._userService.GetHarvestCropDetails(postdata).subscribe(data => {
        this.userdata = data
        this.HarvestDetail = this.userdata.result.data.list
        this.paginationProperty = this.userdata.result.data
        this.length = this.paginationProperty.totalItems
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.HarvestDetail);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }

    else {
      postdata = {
        "fromDate": this.datePipe.transform(this.form.controls.start.value, 'yyyy-MM-ddThh:mm:ss'),
        "toDate": this.datePipe.transform(this.form.controls.end.value, 'yyyy-MM-ddThh:mm:ss'),
        "state": this.filterbystate.join(","),
        "district": this.filterbydistrict.join(","),
        "mostRcent": this.mostrecent,
        "oldest": this.oldRating,
        "highestRating": this.highestRating,
        "lowestRating": this.lowestRating,
        "search": this.filterbyText,
        "pageNumber": this.pageIndex,
        "pageSize": this.pageSize
      }

      this._userService.GetHarvestCropDetails(postdata).subscribe(data => {
        this.userdata = data
        this.HarvestDetail = this.userdata.result.data.list
        this.paginationProperty = this.userdata.result.data
        this.length = this.paginationProperty.totalItems
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.HarvestDetail);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }

  }

  sharedate; filterbysharedate = ""; filterbydistrictName = ""; districtName = "";
  applyFilter(checkEmpty) {
    this.matChipArray = [];
    let totalState = []
    this.statedata.forEach((ele: any) => {
      totalState.push(ele.stateName)
    })

    if (checkEmpty && !this.searchData && totalState.length == 0 && this.districtdata.length == 0 && !this.sharedate.endDate && !this.sharedate.startDate) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbynamedata = this.namedata;
      this.filterbystate = totalState;
      this.filterbydistrict = this.districtdata;

      // this.filterbycategoryname =  this.categoryname;

      let indexnamedata = this.matChipArray.findIndex(x => x.tag === 'namedata');
      let indexstate = this.matChipArray.findIndex(x => x.tag === 'state');
      let indexdistrictdata = this.matChipArray.findIndex(x => x.tag === 'district');
      this.filterbyformdate = this.formdate;
      this.filterbytodayte = this.datePipe.transform(this.todayte, 'yyyy/MM/dd hh:mm:ss');
      //let indexcategoryname = this.matChipArray.findIndex(x => x.tag === 'categoryname');
      let indexformdate = this.matChipArray.findIndex(x => x.tag === 'formdate');
      let indextodayte = this.matChipArray.findIndex(x => x.tag === 'todayte');
      let indexsharedate = this.matChipArray.findIndex(x => x.tag === 'sharedate');
      if (this.namedata != '') {
        if (indexnamedata > -1) {
          this.matChipArray[indexnamedata].name = "Name" + ":" + this.namedata;
        } else {

          if (this.namedata != "" && this.namedata != undefined) {
            this.matChipArray.push({ 'name': "Name" + ":" + this.namedata, 'tag': 'name', 'flag': true })
          }
        }
      }
      if (totalState != null) {
        totalState.forEach(ele => {
          // if (ele.indexstate > -1) {
          //   this.matChipArray[ele.indexstate].name = "State" + ":" + totalState;
          // } else {
          //   if (totalState != null && totalState != undefined) {
          //     this.matChipArray.push({ 'name': "State" + ":" + totalState, 'tag': 'state', 'flag': true })
          //   }
          // }
          this.matChipArray.push({ 'name': "State" + ":" + ele, 'tag': 'state', 'flag': true })

        })

      }


      if (this.districtdata != null) {
        this.districtdata.forEach(ele => {
          this.matChipArray.push({ 'name': "District" + ":" + ele, 'tag': 'district', 'flag': true })

        })
        // if (indexdistrictdata > -1) {
        //   this.matChipArray[indexdistrictdata].name = "District" + ":" + this.districtdata;
        // } else {
        //   if (this.districtdata != "" && this.districtdata != undefined) {
        //     this.matChipArray.push({ 'name': "District" + ":" + this.districtdata, 'tag': 'district', 'flag': true })
        //   }
        // }
      }


      // if (this.state != '') {
      //   if (indexstate > -1) {
      //     this.matChipArray[indexstate].name = "State" + ":" + this.state;
      //   } else {

      //     if (this.state != "" && this.state != undefined) {
      //       this.matChipArray.push({ 'name': "State" + ":" + this.state, 'tag': 'state', 'flag': true })
      //     }
      //   }
      // }
      // if (this.districtName!= '') {
      //   if (indexdistrictName > -1) {
      //       this.matChipArray[indexdistrictName].name = "District" + ":" + this.districtName;
      //     } else {
      //       if (this.districtName != "" && this.districtName != undefined) {
      //         this.matChipArray.push({ 'name': "District" + ":" + this.districtName, 'tag': 'districtName', 'flag': true })
      //       }
      //     }
      //   }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('MM/DD/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('MM/DD/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('MM/DD/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('MM/DD/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }
      // if (this.formdate != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indexformdate].name = "Date Range" + ":" + this.formdate;
      //   } else {

      //     if (this.formdate != "" && this.formdate != undefined) {
      //       this.matChipArray.push({ 'name': "Date Range" + ":" + this.formdate, 'tag': 'formdate', 'flag': true })
      //     }

      //   }
      // }


      // if (this.todayte != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indextodayte].name = "Date Range" + ":" + this.todayte;
      //   } else {

      //     if (this.todayte != "" && this.todayte != undefined) {
      //       this.matChipArray.push({ 'name': "Date Range" + ":" + this.todayte, 'tag': 'todayte', 'flag': true })
      //     }

      //   }
      // }

      var postdata = {
        "fromDate": this.startdata,
        "toDate": this.enddata,
        "search": this.filterbyText,
        "name": this.filterbynamedata,
        "stateName": this.filterbystate.join(","),
        "districtName": (this.filterbydistrict && this.filterbydistrict.length > 0) ? this.filterbydistrict.join(",") : '',
        "pageNumber": 0,
        "pageSize": 10
      }

      this._userService.GetHarvestCropDetails(postdata).subscribe(data => {
        this.HarvestDetail = data;
        this.paginationProperty = this.HarvestDetail.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.totalPages = this.paginationProperty.totalPages;
        this.dataSource = new MatTableDataSource<Element>(this.HarvestDetail.result.data.list);

        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }


  remove(index, tag): void {

    if (tag === 'state') {
      let removedState: any = this.matChipArray.splice(index, 1);
      // this.totalState = "";
      let val = JSON.parse(JSON.stringify(this.statedata));
      let i = val.findIndex(x => (removedState[0].name) === ('State:' + x.stateName));
      val.splice(i, 1);
      // this.bankMultiCtrl.setValue([]);
      this.bankMultiCtrl.setValue(val);
      // this.bankMultiCtrl.setValue(this.statedata);

    }
    if (tag === 'district') {
      let removedDistrict: any = this.matChipArray.splice(index, 1);
      let val = JSON.parse(JSON.stringify(this.districtdata));
      let i = val.findIndex(x => (removedDistrict[0].name) === ('District:' + x.districtName));
      val.splice(i, 1);
      this.districtMultiCtrl.setValue(val);
    }
    // if (this.districtdata != null) {
    //   this.districtdata.forEach(ele => {
    //     this.matChipArray.push({ 'name': "District" + ":" + ele, 'tag': 'district', 'flag': true })

    //   })
    //   // if (indexdistrictdata > -1) {
    //   //   this.matChipArray[indexdistrictdata].name = "District" + ":" + this.districtdata;
    //   // } else {
    //   //   if (this.districtdata != "" && this.districtdata != undefined) {
    //   //     this.matChipArray.push({ 'name': "District" + ":" + this.districtdata, 'tag': 'district', 'flag': true })
    //   //   }
    //   // }
    // }

    // if (tag === 'district') {
    //   let removedDistrict: any = this.matChipArray.splice(index, 1);
    //   let val = JSON.parse(JSON.stringify(this.districtdata));
    //   let i = val.findIndex(x => (removedDistrict[0].name) === ('District:' + x.districtName));
    //   val.splice(i, 1);
    //   this.districtMultiCtrl.setValue(val);
    // }
    // if (tag === 'state') {
    //   this.matChipArray.splice(index, 1);
    //   this.state = "";
    // }

    // if (tag === 'districtName') {
    //   this.matChipArray.splice(index, 1);
    //   this.districtName = "";
    // }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    setTimeout(() => {
      this.applyFilter(false);
    }, 500);
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  companyname; documentStatus; mandi; personName; phoneNo; role; states; taluk; numberOfTrees; treeType;
  commTradeInterest; reqFrequency; aboutUs; profile_Image; address;
  showDocument(data) {

    this.datashowtrader = false;
    this.datashow = false;
    this.datashowfarmer = true;
    this.avtar = false;
    this.Viewprofile = true;
    if (data.role == "TRADER") {
      this.datashowtrader = true;
      this.datashowfarmer = false;
    }
    if (data.profile_Image == null) {
      this.avtar = true;
    }
    this.companyname = data.company
    this.documentStatus = data.documentStatus
    this.mandi = data.mandi
    this.personName = data.personName
    this.phoneNo = data.phoneNo
    this.role = data.role
    this.states = data.states
    this.district = data.district;
    this.taluk = data.taluk;
    this.numberOfTrees = data.numberOfTrees;
    this.treeType = data.treeType;
    this.commTradeInterest = data.commTradeInterest;
    this.reqFrequency = data.reqFrequency;
    this.aboutUs = data.aboutUs;
    this.profile_Image = data.profile_Image;
    this.address = data.address;
    this.documentStatus = data.documentStatus;

  }

  showViews() {
    // this.spinner.show();
    // window.location.reload();
    this.datashow = true;
    this.Viewprofile = false;
    this.spinner.show();
    var postdata = {
      "fromDate": "",
      "toDate": "",
      "month": "",
      "state": "",
      "district": "",
      "mostRcent": true,
      "oldest": false,
      "highestRating": false,
      "lowestRating": false,
      "search": "",
      "pageNumber": 0,
      "pageSize": 10
    }
    this._userService.GetHarvestCropDetails(postdata).subscribe(data => {
      this.userdata = data
      this.HarvestDetailList = this.userdata.result.data.list
      this.paginationProperty = this.userdata.result.data
      this.length = this.paginationProperty.totalItems
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber


      this.dataSource = new MatTableDataSource(this.HarvestDetailList);
      // this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //setTimeout(() => this.dataSource.sort = this.sort);



      this.spinner.hide();
    });
  }

  maindata; apidata; filename;
  exportcsv() {

    if (this.exportcsvdata == true) {
      this.applyFilter(true);

      var postdata = {

        "fromDate": this.filterbyformdate,
        "toDate": this.filterbytodayte,
        "month": this.filterbymonthData,
        "state": this.filterbystate,
        "district": this.filterbydistrictName,
        "mostRcent": true,
        "oldest": false,
        "highestRating": false,
        "lowestRating": false,
        "search": this.filterbyText,

      }

      this._userService.getHarvestDetailReport(postdata).subscribe(data => {
        this.apidata = data;
        const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = "PKF_Harvestlist.xlsx";
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });

    } else {

      var postdata = {
        "fromDate": this.filterbyformdate,
        "toDate": this.filterbytodayte,
        "month": this.filterbymonthData,
        "state": this.filterbystate,
        "district": this.filterbydistrictName,
        "mostRcent": true,
        "oldest": false,
        "highestRating": false,
        "lowestRating": false,
        "search": this.filterbyText,



      }
      this._userService.getHarvestDetailReport(postdata).subscribe(data => {
        this.apidata = data;
        const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement("a");
        anchor.download = "PKF_Harvestlist.xlsx";
        anchor.href = url;
        anchor.click();
      });
    }
  }

  selectItem(item) {
    if (item.value == "Custom Date") {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyFilter(false);
    }

  }


  /*====================================================View Profile ================================================================ */
  city: string;
  name: string;
  food_from_modal: string;

  openDialog(data): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    const dialogRef = this.dialog.open(UserProfileComponent, {
      width: '60%',
      height: '71%',
      data: { name: data.farmerId, farmerData:data
       }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  /* open model pop up */
  /*====================================================View Profile ================================================================ */

  dialogresult;
  mainresult
  openDialogexport(): void {
    const dialogRef = this.dialog.open(TrackExportData, {
      width: '60%',
      height: 'auto',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.dialogresult = result;

      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map(choice => (choice.value));
          let text = confirm("Are you sure you want to export this file?");
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyFilter(true);
              if (this.customDate == true) {
                var postdata = {
                  "fromDate": this.startdata,
                  "toDate": this.enddata,
                  "month": this.filterbymonthData,
                  "state": this.filterbystate.join(","),
                  "district": this.filterbydistrict.join(","),
                  "mostRcent": true,
                  "oldest": false,
                  "highestRating": false,
                  "lowestRating": false,
                  "search": this.filterbyText,
                  "reportList": Result
                }
              }
              else {
                postdata = {

                  "fromDate": this.startdata,
                  "toDate": this.enddata,
                  "month": this.filterbymonthData,
                  "state": this.filterbystate.join(","),
                  "district": this.filterbydistrict.join(","),
                  "mostRcent": true,
                  "oldest": false,
                  "highestRating": false,
                  "lowestRating": false,
                  "search": this.filterbyText,
                  "reportList": Result
                }
              }
              this._userService.getHarvestDetailReport(postdata).subscribe(data => {
                this.apidata = data;
                const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                anchor.download = "PKF_Harvestlist.xlsx";
                anchor.href = url;
                anchor.click();
              });
            } else {
              postdata = {
                "fromDate": this.startdata,
                "toDate": this.enddata,
                "month": this.filterbymonthData,
                "state": this.filterbystate.join(","),
                "district": '',
                "mostRcent": true,
                "oldest": false,
                "highestRating": false,
                "lowestRating": false,
                "search": this.filterbyText,

                "reportList": Result
              }
              this._userService.getHarvestDetailReport(postdata).subscribe(data => {
                this.apidata = data;
                const blob = new Blob([this.apidata], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement("a");
                anchor.download = "PKF_Harvestlist.xlsx";
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport()
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport()
        }
      }

    })
  }
}

/* ===========================================Export-function ==============================================================*/



@Component({
  selector: 'track-export-data',
  templateUrl: 'track-export-data.html',
})
export class TrackExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(

    public dialogRef: MatDialogRef<TrackExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private router: Router) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Farmer', value: 'Farmer', isSelected: false },
      { id: 2, viewValue: 'State', value: 'State', isSelected: false },
      { id: 3, viewValue: 'District', value: 'District', isSelected: false },
      // { id: 4, viewValue: 'Tree Harvested', value: 'TreeHarvested', isSelected: false },
      { id: 5, viewValue: 'Harvest', value: 'Harvest', isSelected: false },
      // { id: 1, value: 'RankInDistrict', isSelected: false },
      // { id: 2, value: 'RankInState', isSelected: false },
      { id: 6, viewValue: 'Date', value: 'Date', isSelected: false },
      { id: 7, viewValue: 'Crop', value: 'Crop', isSelected: false },
      // { id: 7, viewValue: 'Total Tree', value: 'TotalTree', isSelected: false },
      // { id: 8, viewValue: 'Harvest Month', value: 'HarvestMonth', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items



  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    })
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);

  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}